import React, { useContext } from "react";
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap";
import { ViewOfferContext } from "./context";
import { LabelText } from "../../Utils/Input";
import { formatDateForDisplay } from "../../Utils/UtilityFunctions";

const ViewOfferDetails = () => {
  const { values, isOfferNeverExpires, globalState, serviceBarringState } =
    useContext(ViewOfferContext);

  const renderDoubleColumnRow = (
    leftLabel,
    leftValue,
    rightLabel,
    rightValue,
    noBorder = false
  ) => {
    const formatValue = (label, value) => {
      if (!label) return "";
      return value ? value : "-";
    };

    return (
      <div className={`mb-3 pb-2 ${noBorder ? "" : "border-bottom"}`}>
        <Row>
          <Col lg={6} md={6} sm={12}>
            {leftLabel && <label className="fw-semibold">{leftLabel}</label>}
            {/* {leftLabel && <LabelText classLabelName={"rv-form-label"} displayText={leftLabel}/>} */}
            <p className="detail-value mb-0">
              {formatValue(leftLabel, leftValue)}
            </p>
          </Col>
          <Col lg={6} md={6} sm={12}>
            {rightLabel && <label className="fw-semibold">{rightLabel}</label>}
            <p className="detail-value mb-0">
              {formatValue(rightLabel, rightValue)}
            </p>
          </Col>
        </Row>
      </div>
    );
  };
  return (
    <div className="profile-details-section">
      {renderDoubleColumnRow(
        "Offer Name",
        values?.offerName,
        "Offer Code",
        values?.offerCode
      )}
      {renderDoubleColumnRow(
        "Offer Starts On",
        formatDateForDisplay(values?.offerStartsOn),
        isOfferNeverExpires ? "Offer Never Expires" : "Offer Ends On",
        isOfferNeverExpires ? "Yes" : formatDateForDisplay(values?.offerEndsOn)
      )}
      {renderDoubleColumnRow(
        "Categories",
        values?.categories && values?.categories?.length > 0
          ? values?.categories?.map((cat) => cat?.label)?.join(", ")
          : "",
        "Priority",
        values?.offerPriority
      )}
      {renderDoubleColumnRow(
        "Service Name",
        values?.serviceName?.label,
        "Global Offer",
        globalState ? "Yes" : "No"
      )}
      {renderDoubleColumnRow(
        "Policy Specification",
        values?.policyName?.label,
        "Aggregate Resources",
        values?.aggregateVolume?.map((cat) => cat?.label)?.join(", ")
      )}
      {renderDoubleColumnRow(
        "Subscription Starts On",
        values?.subscriptionStartsOn?.label,
        "Subscription Ends On",
        values?.subscriptionEndsOn?.label
      )}
      {renderDoubleColumnRow(
        "Time Period",
        values?.subscriptionEndsOn?.label === "Relative"
          ? `${values?.timePeriod ? values?.timePeriod : "-"} ${
              values?.timePeriodOption ? values?.timePeriodOption?.label : ""
            }`
          : "-",
        "Service Barring",
        serviceBarringState ? "Yes" : "No"
      )}
      <Col xxl={12} md={12}>
        <LabelText
          htmlFor={"description"}
          displayText={"Description"}
          classLabelName={"fw-semibold"}
        />
        <p>{values?.description ? values?.description : "-"}</p>
      </Col>
    </div>
  );
};

export default ViewOfferDetails;
